"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Star, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PawsItivelyPerfectGrooming() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="73761" id="the-royal-cavalier-experience" className="relative w-full overflow-hidden bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1599074/img/image_kwjxe8x1.jpg)] bg-cover bg-center bg-no-repeat py-16 md:py-24 lg:py-32 min-h-[600px] flex items-center">
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent z-0" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-8">
          
          <div ref={leftColRef} className={`lg:col-span-7 flex flex-col items-start text-left transition-all duration-1000 ease-out ${isLeftVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <h1 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-white sm:text-5xl md:text-6xl lg:text-[4.5rem] drop-shadow-lg">
              The Royal Cavalier <span className="text-purple-300 italic !font-extrabold">Experience.</span>
            </h1>
            
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-white/90 font-sans sm:text-xl drop-shadow-md">
              An AKC Breeder of Merit dedicated to the heritage, health, and heart of the Cavalier King Charles Spaniel. Experience the gold standard of ethical breeding.
            </p>
            
            {/* BUTTON CONTAINER: Changed to flex-col for clean vertical stacking */}
            <div className="mt-10 flex flex-col items-start gap-4 sm:gap-5 w-full max-w-md sm:max-w-none">
              
              {/* PRIMARY ACTION: MEET OUR PUPPIES */}
              <div className="relative inline-flex group w-full sm:w-auto">
                <div className="absolute inset-0 rounded-full bg-white/20 animate-ping opacity-75 group-hover:opacity-0 transition-opacity duration-300"></div>
                <Button size="lg" className="relative z-10 h-14 w-full sm:w-auto px-10 text-lg rounded-full shadow-xl transition-transform hover:scale-[1.02] bg-purple-700 text-white hover:bg-purple-800" asChild>
                  <Link to="/Puppies">Meet Our Puppies</Link>
                </Button>
              </div>

              {/* SECONDARY ACTION: VIEW UPCOMING SHOWS */}
              <div className="relative inline-flex group w-full sm:w-auto">
                <Button size="lg" variant="outline" className="relative z-10 h-14 w-full sm:w-auto px-10 text-lg rounded-full shadow-xl transition-transform hover:scale-[1.02] bg-white/10 text-white border-white/40 hover:bg-white hover:text-purple-900 flex items-center justify-center gap-2 backdrop-blur-sm" asChild>
                  <Link to="/ShowSchedule">
                    <SafeHydrate><Calendar className="w-5 h-5 opacity-80" /></SafeHydrate>
                    View Upcoming Shows & Meet the Breeder
                  </Link>
                </Button>
              </div>
              
              <div className="pt-4 w-full">
                <p className="text-sm text-white/70 font-sans uppercase tracking-widest font-bold leading-tight border-l border-white/30 pl-4">
                  AKC BREEDER OF MERIT<br />
                  MEMBER OF THE ACKCSC
                </p>
              </div>
            </div>
          </div>

          <div ref={rightColRef} className={`lg:col-span-5 relative mx-auto w-full max-w-md lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
            <div className="relative h-64 lg:h-auto">
              <div className="absolute -right-6 top-12 z-20 animate-[bounce_4s_ease-in-out_infinite]">
                <Badge variant="default" className="flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold shadow-xl border-2 border-background bg-white text-black">
                  <div className="flex items-center justify-center rounded-full bg-purple-100 p-1">
                    <Star className="h-3 w-3 fill-purple-700 text-purple-700" />
                  </div>
                  AKC Breeder of Merit
                </Badge>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}